import React from 'react';

import Notifications from '../pageComponents/Notifications';

const NotificationsPage = () => <Notifications />;

export default NotificationsPage;
